import { render, staticRenderFns } from "./ProposalDateItem.vue?vue&type=template&id=63d1f56a&scoped=true"
import script from "./ProposalDateItem.vue?vue&type=script&lang=ts"
export * from "./ProposalDateItem.vue?vue&type=script&lang=ts"
import style0 from "./ProposalDateItem.vue?vue&type=style&index=0&id=63d1f56a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d1f56a",
  null
  
)

export default component.exports